<template>
    <div v-loading="loading" class="user-portfolio-competence">
        <div class="user-portfolio-competence__head">
            <div class="user-portfolio-competence__head-title">Компетенции</div>
            <div class="user-portfolio-competence__head-title user-portfolio-competence__head-title--level">
                Уровень
            </div>
        </div>

        <div v-if="competencies.length" class="user-portfolio-competence__list">
            <div
                v-for="(group, index) in competencies"
                :key="`group-${index}`"
                class="user-portfolio-competence__group"
                :class="index + 1 === competencies.length && 'user-portfolio-competence__group--last'"
            >
                <span class="user-portfolio-competence__groupName">{{ group.name }} </span>

                <div
                    v-for="(item, index) in group.items"
                    :key="`item-${index}`"
                    class="user-portfolio-competence__list-item"
                >
                    <div
                        class="user-portfolio-competence__list-item-name"
                        :class="{
                            [`user-portfolio-competence__list-item-name--${item.type}`]: true,
                        }"
                    >
                        <a :href="competenceLink(item.id)" target="_blank">
                            {{ item.name }}
                        </a>
                    </div>
                    <div class="user-portfolio-competence__list-item-level">
                        <span
                            class="user-portfolio-competence__list-item-level-icon"
                            :class="{
                                [`user-portfolio-competence__list-item-level-icon--${item.competenceLevel}`]: true,
                            }"
                        ></span>
                        <span>{{ levelNames[item.competenceLevel] }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="user-portfolio-competence__empty">Нет подтвержденных компетенций</div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        loading: false,
        levelNames: {
            basic: 'базовый',
            intermediate: 'средний',
            advanced: 'продвинутый',
        },
    }),

    async created() {
        this.loading = true;

        await this.loadUserCompetences(this.getUser.userId);

        this.loading = false;
    },

    watch: {
        async 'getUser.userId'(userId) {
            this.loading = true;

            await this.loadUserCompetences(userId);

            this.loading = false;
        },
    },

    computed: {
        ...mapGetters(['isMobile']),
        ...mapGetters('newUsers', ['getUser', 'getUserCompetences']),

        competencies() {
            let items = this.getUserCompetences.filter((v) => v.type === 'soft' && v.competenceLevel);

            const groups = {};
            const noGroup = {
                items: [],
            };

            for (const item of items) {
                if (!item.competenceGroup) {
                    noGroup.items.push(item);
                } else {
                    if (!groups[item.competenceGroup]) {
                        groups[item.competenceGroup] = {
                            name: item.competenceGroup,
                            items: [],
                        };
                    }
                    groups[item.competenceGroup].items.push(item);
                }
            }

            if (noGroup.items.length) {
                return Object.values([noGroup, ...Object.values(groups)]);
            } else {
                return Object.values([...Object.values(groups)]);
            }
        },
    },

    methods: {
        ...mapActions('newUsers', ['loadUserCompetences']),

        competenceLink(id) {
            return `https://${window.rsvDomain}/other-skills/${id}`;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.user-portfolio-competence {
    display: flex;
    flex-direction: column;
    gap: mrem(40);

    @include on-desktop {
        gap: rem(40);
    }

    &__head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        &-title {
            font-weight: 700;
            font-size: mrem(18);
            line-height: mrem(24);

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(24);
            }

            &--level {
                flex: 0 1 auto;
                text-transform: uppercase;

                @include on-desktop {
                    width: rem(150);
                }
            }
        }
    }

    &__group {
        border-bottom: rem(1) solid #d4d4d4;
        padding-bottom: 20px;
        margin-bottom: 30px;

        &--last {
            border: none;
            margin-bottom: 0;
            padding-bottom: 0;

            .user-portfolio-competence__list-item {
                padding-bottom: 0;
            }
        }
    }

    &__groupName {
        font-weight: 600;
        font-size: mrem(18);
        line-height: mrem(24);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(24);
        }
    }

    &__list {
        display: flex;
        flex-direction: column;

        &-item {
            display: flex;
            justify-content: space-between;
            padding: mrem(16) 0;
            //gap: mrem(16);

            @include on-desktop {
                gap: rem(16);
                padding: rem(16) 0;
            }

            &-name {
                position: relative;
                font-weight: 500;
                padding-left: mrem(33);
                width: 50%;

                @include on-desktop {
                    padding-left: rem(30);
                    width: 100%;
                }

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    width: mrem(24);
                    height: mrem(24);
                    top: mrem(0);

                    @include on-desktop {
                        width: rem(24);
                        height: rem(24);
                        top: rem(-2);
                    }
                }
                &--soft {
                    &:before {
                        background: url('~@/assets/images/portfolio/competence.svg') no-repeat center center;
                        background-size: contain;
                    }
                }
                &--hard {
                    &:before {
                        background: url('~@/assets/images/portfolio/competence.svg') no-repeat center center;
                        background-size: contain;
                    }
                }
            }
            &-level {
                flex: 0 1 auto;
                display: grid;
                font-weight: 600;
                grid-template-columns: mrem(26) mrem(120);
                gap: mrem(6);
                font-size: mrem(16);
                line-height: mrem(22);

                @include on-desktop {
                    grid-template-columns: rem(26) rem(120);
                    gap: rem(6);
                    font-size: rem(16);
                    line-height: rem(22);
                }

                &-icon {
                    display: inline-block;
                    width: mrem(26);
                    height: mrem(20);

                    @include on-desktop {
                        width: rem(26);
                        height: rem(20);
                    }

                    &--basic {
                        background: url('~@/assets/images/portfolio/levels/basic.svg') no-repeat center center;
                        background-size: contain;
                    }
                    &--intermediate {
                        background: url('~@/assets/images/portfolio/levels/intermediate.svg') no-repeat center center;
                        background-size: contain;
                    }
                    &--advanced {
                        background: url('~@/assets/images/portfolio/levels/advanced.svg') no-repeat center center;
                        background-size: contain;
                    }
                }
            }
        }
    }

    &__empty {
        color: $color-main-primary;
        font-weight: 500;
    }
}
</style>
